export default "__VITE_ASSET__Ci26Pbaj__"